import styled from 'styled-components'
import { LabeledInput } from '../labeled-input/labeled-input'

export const Labeled = styled(LabeledInput)`
  position: relative;
`

export const Copy = styled.div`
  width: 50px;
  text-align: center;
`
